<template>
  <div>
    <el-input type="hidden"
              v-model="inputvalues22"
              ref="inputvalues22input"></el-input>
    <el-row :gutter="11"
            style="height:20px;">
      <el-col :span="7">
        <span>选项:{{inputvalues22}} </span>
      </el-col>
      <div style="text-align:right;">
        <el-col :span="10">
           <el-col :span="11"><span v-if="inputvaluestrue22 == '20'">选项内的课程在课程开始</span></el-col>
           <el-col :span="6">
          <el-input  ref="days" @change="getupdata" v-model.number="days" oninput="value=value.replace(/[^\d.]/g,'')" v-if="inputvaluestrue22 == '20'"  disabled style="width: 80px; float: left;"></el-input>
          <!-- </el-form-item> -->
           </el-col>
            <el-col :span="6">
              <span  style="padding-left: 5.5px; float: left;" v-if="inputvaluestrue22 == '20'">天前完成</span></el-col>
          <!-- </el-form-item> -->
            <span v-if="inputvaluestrue22 == '10'"> &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;</span>
        </el-col>
        <el-col :span="7">
        </el-col>
      </div>
    </el-row>
    <div v-show="(inputvalues.length > 0)">
      <el-table ref="tbl"
                :key='tableKey'
                :data="inputvalues"
                v-loading.body="listLoading"
                :show-header="false"
                :cell-style="cellStylec"
                style="width: 100%;text-align: left;"
                border
                stripe
                empty-text=" ">
        <el-table-column label="coursecode"
                         prop="course"
                         min-width="100px"
                         width="300px"
                         align="center">
        </el-table-column>
        <el-table-column label="coursecode"
                         prop="courseConditionStatus"
                         min-width="180px"
                         width="400px"
                         align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.courseConditionStatus" disabled
                       multiple
                       filterable
                       allow-create
                       default-first-option
                       placeholder="">
              <!-- <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"> -->
              <el-option v-for="(item,index) in options"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="coursecode"
                         prop="courseKind"
                         min-width="80px"
                         align="center">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
// import courseds from '@/views/modules/learning/course/csbase/courseds'

export default {

  name: 'condition',
  props: {
    // 设置列表文本框是否显示
    days: Number, // String, // 天数
    inputvaluestrue22: String,
    inputvaluesfu: Array, // String, // 父的
    inputvalues: Array, // String, // 父的子内容
    // inputvalues
    inputvalues22: Number, // String, // 父的选项
    inputindex: Number, // String, // 父的index
    sh: {
      type: String,
      default: 'def'
    }
  },
  data () {
    return {
      infiledList: [],
      input: '',
      dialogTableVisible: false,
      val: 'test',
      courselst: [],
      cnt: 0,
      listLoading: '',
      tableKey: '',
      options: this.enums['courseStatusBlend']
    }
  },
  methods: {
    cellStylec ({ row, column, rowIndex, columnIndex }) {
      return {
        background: '#fff'
      }
    },
    inputss: function (data) {
      // var str1 = data
      // var strs = str1.split(',')
      // for (var i = 0; i < strs.length; i++) {
      //   let rd = { coursecode: strs[i], coursename: ['a1'], status: '2' }
      //   this.courselst.push(rd)
      // }
      // var str1 = data
      // var strs = str1.split(',')
      // for (var i = 0; i < strs.length; i++) {
      //   this.infiledList.push({ options: strs[i], optype: '2', state: ['a1'], remark: '' })
      // }
      var nams = this.$refs.inputvalues22input.value
      data.forEach(row => {
        this.infiledList.push({ id: row.id, course: row.course, courseKind: row.courseKind, courseConditionStatus: ['a1'] })
      })
      this.$emit('appenddata', [{ names: nams, data: this.infiledList }])// 'data :传当前的值
      this.infiledList = []
      this.dialogTableVisible = false
    },
    del (idx) {
      this.courselst.splice(idx, 1)
    },
    deleteRow (index, rows) { // 删除改行
      rows.splice(index, 1)
    },
    clickdel (idx) {
      this.$emit('del', idx)
    }
  }
}
</script>
<style>
.div-inline {
  display: inline;
}
.left {
  /*display:inline;*/
  width: 200px;
  /*float:left;*/

   /* background: red; */
}
.right {
  overflow: hidden;

  /* background: blue; */
}
.container {
  width: 100%;
  height: 100%;
}
.left1 {
  float: left;
  width: 200px;
  height: 100%;
  /*background: #ffcafd;*/
}
.right1 {
  height: 100%;
  width: auto;
  margin-left: 200px;
  background: #e3e3e3;
}

.el-table >>> td {
  padding: 1px;
  padding-left: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.el-table >>> th {
  padding: 1px;
  padding-left: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
